import React from 'react';
import { MessageContainer } from '../MessageContainer';
import { gql } from '@urql/core';
import { MyChatBubbleFragment } from '../../../../generated/spin-graphql';

type Props = {
    message: MyChatBubbleFragment;
};

gql`
    fragment MyChatBubble on espin_message {
        ...MessageContainer
    }
`;

export const MyChatBubble: React.FC<Props> = ({ message }) => {
    return (
        <div className="chat-bubble my-chat-bubble">
            <MessageContainer message={message} />
        </div>
    );
};
